<template>
	<register-subsidiary-form :form-data="formData"
		v-on:register="register"
		v-on:cancel="cancel"/>
</template>

<script>
	import RegisterSubsidiaryForm from "./components/RegisterSubsidiaryForm";
	import {encoder} from "@/utils/encodeHelper";
  import {UserRegister} from "@/api/generated/UserRegister";

	export default {
    name: "RegisterSubsidiaryView",

		components: {RegisterSubsidiaryForm},

		provide() {
			return {parentValidator: this.$validator};
		},

		data() {
			return {
				formData: {
					name: "",
					polishName: "",
					englishName: "",
					surname: "",
					phoneNumber: "",
					email: "",
					subBidderType: "SUBSIDIARY"
				},
			};
		},

		methods: {
			register (formData, scope) {
				this.$validator.validateAll(scope).then(() => {
          UserRegister.getValidateUserEmailUniqueness(this, encoder.encodeUrlParam(this.formData.email), successResponse => {
							if (successResponse.unique === false) {
								this.vErrors.add({
									field: 'email',
									msg: 'Nie można zarejestrować użytkownika o takim adresie email',
									scope: 'scope'
								});
							} else {
								UserRegister.postRegisterSubBidder(this, this.formData, response => {
									if (response !== undefined && response.status === "OK") {
										this.$router.push("../app/sub-bidders");
									} else {
										this.$router.push("/error");
									}
								});
							}
						}, errorResponse => {
            let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
                ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
                : "Wystąpił błąd podczas walidacji adresu e-mail";
            this.$messagesBus.$emit("error", errorMessage, errorResponse);
          });
				});
			},

			cancel() {
				window.location.replace("../app/sub-bidders");
			},
		},
	};
</script>
